import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useGetMyParadiseImage, useGetStrings } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { IframeMessages } from "@app/utils/constants"
import { getUrl } from "@app/utils/htmlUtils"

import "./MyParadiseFunnel.css"

export const MyParadiseFunnel = () => {
	const { push } = useCustomNavigation()
	const {
		data: { myParadiseOverviewBookEntrance },
	} = useGetStrings(undefined, { defaultData: {} })
	const { data: image } = useGetMyParadiseImage({ type: "entrance" })

	return (
		<div
			className="myParadiseFunnel h-100"
			style={{ backgroundImage: 'url("' + image || "" + '")' }}
			onClick={() => {
				if (window.self !== window.top) {
					let url = appStore.get("core.languageCode") + "/shop/mtp/funnel-eintritt.php"
					const base = getUrl()
					window.parent.postMessage(IframeMessages.openUrl + ";" + (base + url), "*")
				} else {
					push("/")
				}
			}}
		>
			<div className="f2 text-center color-fg-white pt-2 px-3 h-100 flex flex-center">{myParadiseOverviewBookEntrance}</div>
			{/* placeholder image */}
			<img src={image || ""} style={{ opacity: 0, width: "100%", height: "auto" }} />
		</div>
	)
}
